module.exports = __webpack_public_path__ + "img/chp-white.1046582e.svg";